import { parse } from 'qs';

const decode = (str, decoder, charset) => str;

const qsParseOptions = {
  ignoreQueryPrefix: true,
  comma: true,
  decoder: decode, 
};

const customParse = queryString => {
  const queryTemp = parse(queryString, qsParseOptions);
  const query = Object.keys(queryTemp)
      .reduce((obj, key) => { 
        obj[key] = queryTemp[key].includes(',') ? queryTemp[key].split(',') : queryTemp[key]; 
        return obj;
      }, {});

  return query;
}

const customStringify = query => {
  const parts = Object.keys(query)
      .map(key => { 
        const value = Array.isArray(query[key]) ? query[key].join(",") : query[key];
        return [key, value];
      });

  return parts
    .filter(pair => pair[1].length)
    .map(pair => `${pair[0]}=${pair[1]}`)
    .join("&");
};

export { 
  customParse as parse, 
  customStringify as stringify,
};